var map = {
	"./Aid-active.png": "d92c",
	"./Aid.png": "c9fd",
	"./Equity-active.png": "cf8f",
	"./Equity.png": "44ae",
	"./authority-active.png": "1850",
	"./authority.png": "cbfe",
	"./key-active.png": "a230",
	"./key.png": "86cc",
	"./lecture-active.png": "b53f",
	"./lecture.png": "d8e0",
	"./lesson-active.png": "0f09",
	"./lesson.png": "b759",
	"./midihome2-active.png": "7a18",
	"./midihome2.png": "56aa",
	"./organization-active.png": "b906",
	"./organization.png": "edbb",
	"./personnel-active.png": "4e82",
	"./personnel.png": "5d41",
	"./question-active.png": "2860",
	"./question.png": "18a9",
	"./resources-active.png": "58f2",
	"./resources.png": "b43e",
	"./score-active.png": "d432",
	"./score.png": "37df",
	"./sing-active.png": "1dcc",
	"./sing.png": "cf0f",
	"./test-active.png": "a896",
	"./test.png": "85b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "949c";